import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const frjBanner = ({ colours }: Theme) => css`
  height: 32px;
  width: 100%;
  box-shadow:
    0 0 12px -6px ${colours.uIGrey.light._40},
    inset 0 0 4px 2px ${colours.uIGrey.light._40},
    inset 0 0 0 0.5px ${colours.uIGrey.light._10},
    inset 0 -6px 12px -2px #fff;
  background-color: ${colours.uIGrey.light._20};
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: Manrope;
  font-size: 14px;
  line-height: 1.58;
  color: ${colours.uIGrey.mid.dark_20};
`;

export const breadcrumbItem = css`
  font-family: Urbanist;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(18, 23, 42, 0.8);
`;

export const breadcrumbLink = css`
  ${breadcrumbItem}
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const frjTagLink = css`
  font-size: 12px;
  font-family: Urbanist;
  font-weight: 600;
  letter-spacing: 1.2px;
  color: #353d66;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const frjArticleTitle = css`
  font-family: Spectral;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.17;
  color: #12172a;
`;

export const frjArticleExcerpt = css`
  font-family: Spectral;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.16px;
  color: rgba(18, 23, 42, 0.8);
`;

export const frjArticleDate = css`
  font-family: Urbanist;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12px;
  color: rgba(18, 23, 42, 0.8);
`;

export const frjArticleAuthor = css`
  font-family: Spectral;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.16px;
  color: rgba(18, 23, 42, 0.8);
`;

export const frjNavLink = css`
  font-family: Spectral;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  letter-spacing: -0.16px;
  color: #1a1f4c;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const frjArticleUrlToCompassUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.pathname) {
      parsedUrl.pathname = `/article${parsedUrl.pathname.replace(/\/$/, "")}`;
    }
    if (parsedUrl.hash) {
      parsedUrl.searchParams.set("scrollTo", parsedUrl.hash.replace(/#/, ""));
      parsedUrl.hash = "";
    }
    // return relative URL without origin
    return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
  } catch {
    // if URL parsing fails, return the original URL as a fallback
    return url;
  }
};
